export default __webpack_public_path__ + "static/media/uy.96a11592.svg";